import { UserManager, WebStorageStateStore } from "oidc-client-ts"; // Используем новый пакет
import { globalConfig } from "../configuration/config";

export default class AuthService {
  constructor() {
    const settings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: globalConfig.config.auth.authority,
      client_id: globalConfig.config.auth.client_id,
      response_type: globalConfig.config.auth.response_type,
      scope: globalConfig.config.auth.scope,

      automaticSilentRenew: globalConfig.config.auth.automaticSilentRenew,
      redirect_uri: globalConfig.config.auth.redirect_uri,
      silent_redirect_uri: globalConfig.config.auth.silent_redirect_uri,
      post_logout_redirect_uri: globalConfig.config.auth.post_logout_redirect_uri,
    };

    this.userManager = new UserManager(settings);
  }

  async getUser() {
    return this.userManager.getUser();
  }

  login() {
    return this.userManager.signinRedirect();
  }

  postlogin() {
    return this.userManager.signinRedirectCallback();
  }

  renewToken() {
    return this.userManager.signinSilent();
  }

  postrenewToken() {
    return this.userManager.signinSilentCallback();
  }

  logout() {
    return this.userManager.signoutRedirect();
  }

  postLogout() {
    return this.userManager.signoutRedirectCallback();
  }

  removeUser() {
    return this.userManager.removeUser();
  }
}
